'use es6';

import { PERMISSION_DENIED, LACKS_SALES_ANALYTICS_ACCESS, LACKS_BUILDER, CUSTOM_REPORT_LIMIT_EXCEEDED, LACKS_ATTRIBUTION_REPORT_ACCESS, LACKS_DATASETS_ACCESS, LACKS_FIELD_ACCESS, LACKS_MULTI_ACCOUNT_REPORTS_VIEWER_ACCESS } from 'dashboard-lib/private/action-problem-solution/actions/view-report/problem';
import { CUSTOM_DASHBOARD_LIMIT_EXCEEDED_AND_DASHBOARD_SHOULD_LOCKDOWN } from 'dashboard-lib/private/action-problem-solution/problems/lockdown-problem';
import { LACKS_PAYMENTS_REPORT_ACCESS } from 'dashboard-lib/private/action-problem-solution/problems/payment-reporting-problem';
import { LACKS_SNOWFLAKE_TEMPLATE_ACCESS } from 'dashboard-lib/private/action-problem-solution/problems/snowflake-template-problem';
import { indexBy } from 'dashboard-lib/private/js-util';
import { CUSTOM_DASHBOARD_COUNT, CUSTOM_DASHBOARD_LIMIT, CUSTOM_REPORT_COUNT, CUSTOM_REPORT_LIMIT, MARKETING_HUB_UPGRADE_REQUIRED, RESTRICTED_FIELD_LEVEL_PROPERTIES } from 'dashboard-lib/private/action-problem-solution/params/all-params';
import { getAndCheck } from 'dashboard-lib/private/action-problem-solution/common/get-and-check-param';
import { createDisabledMessage } from '../common/disabled-message';
import { createReactMessage, getId } from '../common/message';
import { getDatasetsUpgradeUrl, getManageDashboardsUrl, getManageReportsUrl } from '../common/links';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import ViewReportErrorWrapper from '../../error/ViewReportErrorWrapper';
import ReportBuilderPql from '../../pql/ReportBuilderPql';
import RestrictedFieldsProblemMessage from '../common/RestrictedFieldsProblemMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SALES_ANALYTICS_UPGRADE_KEY = 'dashboard-sales-analytics';
const ATTRIBUTION_PRO_UPGRADE_KEY = 'dashboard-attribution-pro';
const ATTRIBUTION_ENTERPRISE_UPGRADE_KEY = 'dashboard-attribution-enterprise';
const SCOPE_TO_ATTRIBUTION_UPGRADE_KEY = {
  Pro: ATTRIBUTION_PRO_UPGRADE_KEY,
  Enterprise: ATTRIBUTION_ENTERPRISE_UPGRADE_KEY
};

// Error message components to display in place of a report
const ProblemComponents = [createReactMessage(PERMISSION_DENIED, () => /*#__PURE__*/_jsx(ViewReportErrorWrapper, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.PERMISSION_DENIED.title"
  }),
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.PERMISSION_DENIED.body"
    })
  })
})), createReactMessage(LACKS_SALES_ANALYTICS_ACCESS, () => {
  const {
    openUpgradeModal
  } = useUpgradeModal(SALES_ANALYTICS_UPGRADE_KEY);
  return /*#__PURE__*/_jsxs(ViewReportErrorWrapper, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_SALES_ANALYTICS_ACCESS.title"
    }),
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reportingActions.VIEW_REPORT.problem.LACKS_SALES_ANALYTICS_ACCESS.body"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: openUpgradeModal,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reportingActions.VIEW_REPORT.problem.LACKS_SALES_ANALYTICS_ACCESS.cta"
        })
      })
    })]
  });
}), createReactMessage(LACKS_ATTRIBUTION_REPORT_ACCESS, params => {
  const scopeRequirement = getAndCheck(MARKETING_HUB_UPGRADE_REQUIRED, params);
  const upgradeKey = SCOPE_TO_ATTRIBUTION_UPGRADE_KEY[scopeRequirement];
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeKey);
  return /*#__PURE__*/_jsxs(ViewReportErrorWrapper, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `reportingActions.VIEW_REPORT.problem.${upgradeKey}.title`,
      options: {
        scopeRequirement
      }
    }),
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `reportingActions.VIEW_REPORT.problem.${upgradeKey}.body`,
        options: {
          scopeRequirement
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(Button, {
        onClick: openUpgradeModal,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `reportingActions.VIEW_REPORT.problem.${upgradeKey}.cta`
        })
      })
    })]
  });
}), createReactMessage(LACKS_BUILDER, ({
  builderUpgradeLocation
}) => /*#__PURE__*/_jsxs(ViewReportErrorWrapper, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.LACKS_BUILDER.title"
  }),
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_BUILDER.body"
    })
  }), builderUpgradeLocation && /*#__PURE__*/_jsx(ReportBuilderPql, {
    hideLockIcon: true,
    messageKey: "reportingActions.VIEW_REPORT.problem.LACKS_BUILDER.cta",
    upgradeLocation: builderUpgradeLocation
  })]
})), createReactMessage(LACKS_DATASETS_ACCESS, () => /*#__PURE__*/_jsxs(ViewReportErrorWrapper, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.LACKS_DATASETS_ACCESS.title"
  }),
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_DATASETS_ACCESS.body"
    })
  }), /*#__PURE__*/_jsx(Button, {
    href: getDatasetsUpgradeUrl(),
    external: true,
    use: "tertiary",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_DATASETS_ACCESS.cta"
    })
  })]
})), createReactMessage(LACKS_FIELD_ACCESS, params => {
  const restrictedFieldLevelProperties = getAndCheck(RESTRICTED_FIELD_LEVEL_PROPERTIES, params);
  return /*#__PURE__*/_jsx(ViewReportErrorWrapper, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_FIELD_ACCESS.title",
      options: {
        count: restrictedFieldLevelProperties.length
      }
    }),
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(RestrictedFieldsProblemMessage, {
        restrictedFieldLevelProperties: restrictedFieldLevelProperties
      })
    })
  });
}), createReactMessage(CUSTOM_DASHBOARD_LIMIT_EXCEEDED_AND_DASHBOARD_SHOULD_LOCKDOWN, params => /*#__PURE__*/_jsxs(ViewReportErrorWrapper, {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.CUSTOM_DASHBOARD_LIMIT_EXCEEDED_AND_DASHBOARD_SHOULD_LOCKDOWN.body",
    options: {
      customDashboardCount: getAndCheck(CUSTOM_DASHBOARD_COUNT, params),
      customDashboardLimit: getAndCheck(CUSTOM_DASHBOARD_LIMIT, params)
    }
  }), /*#__PURE__*/_jsx(Link, {
    href: getManageDashboardsUrl(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.CUSTOM_DASHBOARD_LIMIT_EXCEEDED_AND_DASHBOARD_SHOULD_LOCKDOWN.cta"
    })
  })]
})), createReactMessage(CUSTOM_REPORT_LIMIT_EXCEEDED, params => /*#__PURE__*/_jsxs(ViewReportErrorWrapper, {
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.CUSTOM_REPORT_LIMIT_EXCEEDED.body",
    options: {
      customReportCount: getAndCheck(CUSTOM_REPORT_COUNT, params),
      customReportLimit: getAndCheck(CUSTOM_REPORT_LIMIT, params)
    }
  }), /*#__PURE__*/_jsx(Link, {
    href: getManageReportsUrl(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.CUSTOM_REPORT_LIMIT_EXCEEDED.cta"
    })
  })]
})), createReactMessage(LACKS_PAYMENTS_REPORT_ACCESS, () => /*#__PURE__*/_jsx(ViewReportErrorWrapper, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.LACKS_PAYMENTS_REPORT_ACCESS.title"
  }),
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_PAYMENTS_REPORT_ACCESS.message"
    })
  })
})), createReactMessage(LACKS_SNOWFLAKE_TEMPLATE_ACCESS, () => /*#__PURE__*/_jsx(ViewReportErrorWrapper, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reportingActions.VIEW_REPORT.problem.LACKS_SNOWFLAKE_TEMPLATE_ACCESS.title"
  }),
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reportingActions.VIEW_REPORT.problem.LACKS_SNOWFLAKE_TEMPLATE_ACCESS.message"
    })
  })
}))];

// Simple disabled messages to display in a tooltip
const ProblemMessages = [createReactMessage(PERMISSION_DENIED, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.VIEW_REPORT.problem.PERMISSION_DENIED.message"
})), createReactMessage(LACKS_SALES_ANALYTICS_ACCESS, () => {
  const {
    openUpgradeModal
  } = useUpgradeModal(SALES_ANALYTICS_UPGRADE_KEY);
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "reportingActions.VIEW_REPORT.problem.LACKS_SALES_ANALYTICS_ACCESS.message_jsx",
    options: {
      onClick: openUpgradeModal
    },
    elements: {
      Link
    }
  });
}), createReactMessage(LACKS_ATTRIBUTION_REPORT_ACCESS, params => {
  const scopeRequirement = getAndCheck(MARKETING_HUB_UPGRADE_REQUIRED, params);
  const upgradeKey = SCOPE_TO_ATTRIBUTION_UPGRADE_KEY[scopeRequirement];
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `reportingActions.VIEW_REPORT.problem.${upgradeKey}.title`
  });
}), createReactMessage(LACKS_BUILDER, () => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
  message: "reportingActions.VIEW_REPORT.problem.LACKS_BUILDER.message"
})), createReactMessage(LACKS_DATASETS_ACCESS, () => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: "reportingActions.VIEW_REPORT.problem.LACKS_DATASETS_ACCESS.message_jsx",
  elements: {
    UILink: Link
  },
  options: {
    url: getDatasetsUpgradeUrl()
  }
})), createReactMessage(LACKS_FIELD_ACCESS, params => {
  const restrictedFieldLevelProperties = getAndCheck(RESTRICTED_FIELD_LEVEL_PROPERTIES, params);
  return /*#__PURE__*/_jsx(RestrictedFieldsProblemMessage, {
    message: 'reportingActions.VIEW_REPORT.problem.LACKS_FIELD_ACCESS.message',
    restrictedFieldLevelProperties: restrictedFieldLevelProperties
  });
}), createReactMessage(CUSTOM_DASHBOARD_LIMIT_EXCEEDED_AND_DASHBOARD_SHOULD_LOCKDOWN, params => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.VIEW_REPORT.problem.CUSTOM_DASHBOARD_LIMIT_EXCEEDED_AND_DASHBOARD_SHOULD_LOCKDOWN.message",
  options: {
    customDashboardCount: getAndCheck(CUSTOM_DASHBOARD_COUNT, params),
    customDashboardLimit: getAndCheck(CUSTOM_DASHBOARD_LIMIT, params)
  }
})), createReactMessage(CUSTOM_REPORT_LIMIT_EXCEEDED, params => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.VIEW_REPORT.problem.CUSTOM_REPORT_LIMIT_EXCEEDED.message",
  options: {
    customReportCount: getAndCheck(CUSTOM_REPORT_COUNT, params),
    customReportLimit: getAndCheck(CUSTOM_REPORT_LIMIT, params)
  }
})), createReactMessage(LACKS_PAYMENTS_REPORT_ACCESS, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.VIEW_REPORT.problem.LACKS_PAYMENTS_REPORT_ACCESS.descriptiveMessage"
})), createReactMessage(LACKS_SNOWFLAKE_TEMPLATE_ACCESS, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.VIEW_REPORT.problem.LACKS_SNOWFLAKE_TEMPLATE_ACCESS.descriptiveMessage"
})), createReactMessage(LACKS_MULTI_ACCOUNT_REPORTS_VIEWER_ACCESS, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.VIEW_REPORT.problem.LACKS_MULTI_ACCOUNT_REPORTS_VIEWER_ACCESS.title"
}))];
const _problemToMessage = indexBy(getId, ProblemMessages);
const _problemToComponent = indexBy(getId, ProblemComponents);

// @params {{
//    CUSTOM_DASHBOARD_COUNT {Number},
//    CUSTOM_DASHBOARD_LIMIT {Number},
//    CUSTOM_REPORT_COUNT {Number},
//    CUSTOM_REPORT_LIMIT {Number},
//    builderUpgradeLocation {String} one of the REPORT_BUILDER_UPGRADE_LOCATIONS in dashboard-lib/public/upgradePointKeys
// }}
// @problem {String}
export function getViewReportError(params, problem) {
  return createDisabledMessage(params, problem, _problemToComponent);
}

// @params {{
//    CUSTOM_DASHBOARD_COUNT {Number},
//    CUSTOM_DASHBOARD_LIMIT {Number},
//    CUSTOM_REPORT_COUNT {Number},
//    CUSTOM_REPORT_LIMIT {Number},
// }}
// @problem {String}
export function getViewReportDisabledMessage(params, problem) {
  return createDisabledMessage(params, problem, _problemToMessage);
}